import { useEffect } from "react";
import { useMap } from "react-leaflet";

/**
 * #1619 (D439) — reports the LIVE longitude of the view centre after every move or zoom.
 *
 * The wrapping maps draw each pin and count bubble at the copy of its longitude nearest the view
 * (`placeLatLng`/`placeCells` in `lib/mapFit.js`). The view centre is not the fit's centre once the player pans:
 * with `worldCopyJump` it is kept within -180..180, so a pan east past 180 jumps it to the other copy, and anything
 * drawn near the old anchor is a world's width away. Reads only on `moveend`/`zoomend`; mount-time placement comes
 * from the caller's initial value.
 */
export default function LiveCentreLng({ onChange }) {
  const map = useMap();
  useEffect(() => {
    const report = () => onChange(map.getCenter().lng);
    map.on("moveend", report);
    map.on("zoomend", report);
    return () => {
      map.off("moveend", report);
      map.off("zoomend", report);
    };
  }, [map, onChange]);
  return null;
}
